import { DEFAULT_SAMPLE, lenLabel } from "./sampler";

const FULL = 301; // past 5 minutes = whole songs

// Sample mode length: any length from 3 seconds to full songs (22 s to start).
export const SampleSlider = ({ value, onChange }) => (
  <div className="px-4 pb-2 flex items-center gap-2" data-testid="player-sample-lengths">
    <span className="text-[10px] font-bold uppercase tracking-wider text-amber-300 shrink-0">Sample</span>
    <input
      type="range" min={3} max={FULL} step={1}
      value={value === Infinity ? FULL : value}
      onChange={(e) => { const n = +e.target.value; onChange(n >= FULL ? Infinity : n); }}
      className="flex-1 accent-amber-400 h-1 cursor-pointer"
      aria-label="Sample length" data-testid="player-sample-slider"
    />
    <span className="w-10 text-right text-[11px] font-bold tabular-nums" data-testid="player-sample-value">{lenLabel(value)}</span>
    {value !== DEFAULT_SAMPLE && (
      <button type="button" onClick={() => onChange(DEFAULT_SAMPLE)} className="rounded-full border border-white/25 px-1.5 text-[10px] font-bold text-white/70 hover:bg-white/10" title="Back to 22 seconds" data-testid="player-sample-reset">22s</button>
    )}
  </div>
);
